import { useState } from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import Avatar from "@mui/material/Avatar";
import Accordion from "@mui/material/Accordion";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Div from "@jumbo/shared/Div";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import List from "@mui/icons-material/List";
import { toast } from "react-toastify";
import MappingTenantModal from "./MappingTenantModal";
import EditTenantModal from "./EditTenantModal";
import DeleteTenantModal from "./DeleteTenantModal";
import { axios_superadmin } from "../../../../../axios";

const SuperAdminTenantCard = ({ tenant, handleEditSubmit, editLoading }) => {
    const [openList, setOpenList] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false); 
    const [tenantValues, setTenantValues] = useState({
        tenantName: tenant.tenantName,
        sftpConfig: tenant.sftpConfig,
        isActive: tenant.isActive,
        sessionExpire: tenant.sessionExpire
    });
    const [selectedValue, setSelectedValue] = useState(tenant.isActive ? 'enabled' : 'disabled');
    const [checkedItems, setCheckedItems] = useState(tenant.Apps);
    const [loading,setLoading] = useState(false);

    const handleClickList = () => {
        setOpenList(!openList);
        setOpenDelete(false);
        setOpenEdit(false);
    };

    const handleClickEdit = () => {
        setTenantValues({
            tenantName: tenant.tenantName,
            sftpConfig: tenant.sftpConfig,
            isActive: tenant.isActive,
            sessionExpire:tenant.sessionExpire
        })
        setOpenEdit(!openEdit);
        setOpenList(false);
        setOpenDelete(false);
    };

    const handleClickDelete = () => {
        setSelectedValue(tenant.isActive ? 'enabled' : 'disabled');
        setOpenDelete(!openDelete);
        setOpenList(false);
        setOpenEdit(false);
    };

    const handleListChange = appId => {
        setCheckedItems(prevItems => {
            return prevItems.map(item => (item.app_id === appId ? { ...item, TenantAppMapping: { isactive: !item.TenantAppMapping.isactive } } : item));
        });
    };

    const updateBody = [];

    checkedItems?.map((p, i) => {
        updateBody.push({
            app_id: p.app_id,
            isActive: p.TenantAppMapping.isactive
        });
    });

    const handleListSubmit = async id => {
        setLoading(true);
        try {
            const response = await axios_superadmin.post(`/superAdmin/apps/mappings/${id}`, { mappings: updateBody });
            if (response) {
                toast.success(response.data.message);
            }
        } catch (err) {
        } finally {
            setLoading(false);
            setOpenList(false);
        }
    };

    const handleEditChange = e => {
        const { id, value } = e.target;

        if (id.includes('.')) {
            const [parent, child] = id.split('.');
            setTenantValues(prevState => ({
                ...prevState,
                [parent]: {
                    ...prevState[parent],
                    [child]: value
                }
            }));
        } else {
            setTenantValues({ ...tenantValues, [id]: value });
        }
    };

    const handleEditClickSubmit = async id => {
        await handleEditSubmit(id, tenantValues);
        setOpenEdit(false);
    };
    

    const handleDeleteChange = event => {
        setSelectedValue(event.target.value);
        setTenantValues({...tenantValues, isActive : event.target.value === "enabled"})
    };

    const handleDeleteSubmit = async id  => {
        await handleEditSubmit(id, {isActive: selectedValue === "enabled"});
        setOpenDelete(false);
    };

    const convertToBase64 = async file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setTenantValues({ ...tenantValues, tenant_image_url: reader.result })
        };
        
    };

    const handleFileChange = async e => {
        let file = e.target.files[0];

        try {
            await convertToBase64(file);
        } catch (error) {
        }
    };

    return (
        <Card sx={{ mb: 1 }}>
            <Accordion square sx={{ borderRadius: 2 }}>
                <AccordionSummary
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{
                        px: 3,
                        flexDirection: "row-reverse",

                        "& .MuiAccordionSummary-content": {
                            alignItems: "center",

                            "&.Mui-expanded": {
                                margin: "12px 0"
                            }
                        },
                        ".MuiAccordionSummary-expandIconWrapper": {
                            borderRadius: 1,
                            border: 1,
                            color: "text.secondary",
                            borderColor: "divider",
                            transform: "none",
                            height: 28,
                            width: 28,
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1,

                            "&.Mui-expanded": {
                                transform: "none",
                                color: "primary.main",
                                borderColor: "primary.main"
                            },

                            "& svg": {
                                fontSize: "1.25rem"
                            }
                        }
                    }}
                >
                    <Div sx={{ flexShrink: 0, px: 1 }}>
                        <Avatar sx={{ width: 52, height: 52 }} alt={tenant.tenantName} src={tenant.tenant_image_url} variant="rounded" />
                    </Div>
                    <Div
                        sx={{
                            width: { xs: "auto", lg: "26%" },
                            flexShrink: 0,
                            px: 1,
                            flex: { xs: "1", lg: "0 1 auto" }
                        }}
                    >
                        <Typography variant={"h5"} mb={0.5} fontSize={17}>
                            {tenant.tenantName}
                        </Typography>
                    </Div>
                    <Div sx={{ display: { xs: "none", lg: "block" }, width: "20%", flexShrink: 0, px: 2 }}></Div>
                    <Div sx={{ display: { xs: "none", lg: "block" }, width: "16%", flexShrink: 0, px: 1 }}></Div>
                    <Div sx={{ flex: { xs: "0 1 auto", lg: 1 }, flexShrink: 0, px: 1 }}></Div>

                    <Typography variant={"h6"} mt={1} lineHeight={1.25}>
                        <List onClick={handleClickList} style={{ cursor: "pointer" }} /> <Edit onClick={handleClickEdit} style={{ cursor: "pointer" }} /> <Delete onClick={handleClickDelete} style={{ cursor: "pointer" }} />
                    </Typography>

                    <MappingTenantModal
                        openList = {openList}
                        setOpenList = {setOpenList}
                        checkedItems = {checkedItems}
                        handleListChange = {handleListChange}
                        handleListSubmit = {handleListSubmit}
                        tenantId = {tenant.subscriptionId}
                        loading={loading}
                    />

                    <EditTenantModal 
                        openEdit = {openEdit}
                        setOpenEdit = {setOpenEdit}
                        sftpHost = {tenantValues.sftpConfig.host}
                        sftpUserName = {tenantValues.sftpConfig.username}
                        sftpPassword = {tenantValues.sftpConfig.password}
                        sessionExpire = {tenantValues.sessionExpire}
                        tenantId = {tenant.subscriptionId}
                        handleEditChange = {handleEditChange}
                        handleFileChange = {handleFileChange}
                        handleEditClickSubmit = {handleEditClickSubmit}
                        loading = {editLoading}
                    /> 

                    <DeleteTenantModal
                        openDelete = {openDelete}
                        setOpenDelete = {setOpenDelete}
                        selectedValue = {selectedValue}
                        handleDeleteChange = {handleDeleteChange}
                        handleDeleteSubmit = {handleDeleteSubmit}
                        tenantId = {tenant.subscriptionId}
                        loading = {editLoading}
                    />
                </AccordionSummary>
            </Accordion>
        </Card>
    );
};

export default SuperAdminTenantCard;
